//
// Copyright 2023 DXOS.org
//

export const DXOS_VERSION = '0.8.2'; // {x-release-please-version}
